/**
 * スムーススクロールを設定
 * @description aタグにhref属性の値が#前方一致で該当コンテンツにスクロール移動 href属性が、#のみ又は、値なしの場合は画面一番上にスクロール移動
 */
export function setSmoothScroll(): void {
  setPageScroll();
  openPageScroll();
}

// 開いたページでページ内スクロールを実行する
function openPageScroll(): void {
  const meta: string[] = ' !"$%&\'()*+,./:;<=>?@[]^`{|}~'.split('');
  const hash: string = location.hash;
  if (hash !== '' && !meta.some((v) => hash.indexOf(v) != -1)) {
    $(window).on('load', () => ankerScroll(hash));
  }
}

// ページ内スクロールを設定する
function setPageScroll(): void {
  $('a[href^="#"]').on('click', (e) => {
    const me = $(e.currentTarget);
    if (me.hasClass('noscroll')) return false;
    ankerScroll(me.attr('href') ?? '');
  });
}

// アンカー位置にページスクロールさせる
function ankerScroll(href: string): void {
  const speed: number = 400;
  const target: JQuery = $(href == '#' || href == undefined || href == '' ? 'html' : href);
  if (!target.length) return;
  const fix: number = $('.header').outerHeight() ?? 0;
  const top: number = (target.offset()?.top ?? 0) - fix;
  $('body,html').animate({ scrollTop: top }, speed, 'swing');
}
